// File: noviopus-ats-client/src/Pages/Job/jobTracks.ts

export const STEP_BASICS = 'basics';
export const STEP_BRAND = 'brand';
export const STEP_REQUIREMENTS = 'requirements';
export const STEP_WORKFLOW = 'workflow';

export const getJobStepPath = (jobId: string, step: string) => {
    return `/jobs/${jobId}/new/${step}`;
};

// Returns the ordered list of paths for the active track
export const getJobWizardTracks = (jobId: string, useDefaults: boolean) => {
    const root = `/jobs/${jobId}/new`;

    const basics = `${root}/${STEP_BASICS}`;
    const brand = `${root}/${STEP_BRAND}`;
    const requirements = `${root}/${STEP_REQUIREMENTS}`;
    const workflow = `${root}/${STEP_WORKFLOW}`;

    if (useDefaults) {
        // Fast Track (3 Steps)
        return [basics, requirements, workflow];
    } else {
        // Full Track (4 Steps)
        return [basics, brand, requirements, workflow];
    }
};

// Legacy compatibility (if needed for old configs)
export const getJobWizardSteps = (useDefaults: boolean): string[] => {
    // This returns the GENERIC paths for the stepper labels config
    // (Used by flowConfig.ts logic usually, but here we dynamic paths)
    return useDefaults 
        ? [STEP_BASICS, STEP_REQUIREMENTS, STEP_WORKFLOW]
        : [STEP_BASICS, STEP_BRAND, STEP_REQUIREMENTS, STEP_WORKFLOW];
};